var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSportHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427319036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427319028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427319035"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 103",
    width: 38,
    height: 38,
    rx: 3,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1071 20.9792C27.701 20.9792 28.1824 21.4642 28.1824 22.0625V30.8622C28.1824 31.4605 27.701 31.9455 27.1071 31.9455C26.5132 31.9455 26.0318 31.4605 26.0318 30.8622V22.0625C26.0318 21.4642 26.5132 20.9792 27.1071 20.9792Z",
    fill: "#F9F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07528 20.9791C9.66914 20.9791 10.1506 21.4641 10.1506 22.0624V30.8621C10.1506 31.4604 9.66914 31.9454 9.07528 31.9454C8.48142 31.9454 8 31.4604 8 30.8621V22.0624C8 21.4641 8.48142 20.9791 9.07528 20.9791Z",
    fill: "#F9F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9247 20.9792C30.5186 20.9792 31 21.4642 31 22.0625V30.8622C31 31.4605 30.5186 31.9455 29.9247 31.9455C29.3309 31.9455 28.8494 31.4605 28.8494 30.8622V22.0625C28.8494 21.4642 29.3309 20.9792 29.9247 20.9792Z",
    fill: "#F9F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.456 20.9792C13.0498 20.9792 13.5312 21.4642 13.5312 22.0625V30.8622C13.5312 31.4605 13.0498 31.9455 12.456 31.9455C11.8621 31.9455 11.3807 31.4605 11.3807 30.8622V22.0625C11.3807 21.4642 11.8621 20.9792 12.456 20.9792Z",
    fill: "#F9F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0836 26.0365C25.0836 26.6349 24.6022 27.1199 24.0084 27.1199H15.2741C14.6803 27.1199 14.1988 26.6349 14.1988 26.0365C14.1988 25.4382 14.6803 24.9532 15.2741 24.9532H24.0084C24.6022 24.9532 25.0836 25.4382 25.0836 26.0365Z",
    fill: "#F9F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9286 6.16564C19.2421 5.96748 19.6347 5.94569 19.9679 6.10796L27.9869 10.0129C28.3583 10.1937 28.5943 10.5727 28.5943 10.9882C28.5943 11.4038 28.3583 11.7828 27.9869 11.9636L20.5753 15.5728V30.9167C20.5753 31.515 20.0939 32 19.5 32C18.9061 32 18.4247 31.515 18.4247 30.9167V7.08333C18.4247 6.71046 18.6151 6.36379 18.9286 6.16564ZM20.5753 13.1663L25.0481 10.9882L20.5753 8.81018V13.1663Z",
    fill: "#F9F7F7"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportHover);
export default __webpack_public_path__ + "static/media/sport-hover.43fa41f0e4033d27bb465f4234cafe82.svg";
export { ForwardRef as ReactComponent };